export default "query GiftCardValidationRules($locale:Locale!){validationRules:validationRules_v2(locale:$locale){giftCard{code{...ValidationRuleAttributes}}}}"